import type { LiveBrb } from '@/types';
import { LiveSplash } from './components/LiveSplash';

// GET /:eventSlug/live/brb — what OBS shows between presentation blocks.
export default function Brb({ splash }: LiveBrb) {
  return (
    <>
      <LiveSplash
        splash={splash}
        subtitle="Presentaciones finales"
        message="Ya volvemos"
      />
    </>
  );
}
